import {
  EmailSentHistoryFilters,
  EmailSentHistoryResponse,
} from '../../types/emailSentHistory/emailSentHistory.types';

// Action Types
export const GET_EMAIL_SENT_HISTORY_REQUEST = 'GET_EMAIL_SENT_HISTORY_REQUEST';
export const GET_EMAIL_SENT_HISTORY_SUCCESS = 'GET_EMAIL_SENT_HISTORY_SUCCESS';
export const GET_EMAIL_SENT_HISTORY_FAILURE = 'GET_EMAIL_SENT_HISTORY_FAILURE';

export const GET_DRAFT_EMAILS_REQUEST = 'GET_DRAFT_EMAILS_REQUEST';
export const GET_DRAFT_EMAILS_SUCCESS = 'GET_DRAFT_EMAILS_SUCCESS';
export const GET_DRAFT_EMAILS_FAILURE = 'GET_DRAFT_EMAILS_FAILURE';

export const CLEAR_EMAIL_SENT_HISTORY_SUCCESS =
  'CLEAR_EMAIL_SENT_HISTORY_SUCCESS';

export const CLEAR_DRAFT_EMAILS_SUCCESS = 'CLEAR_DRAFT_EMAILS_SUCCESS';

export const SEND_EMAIL_REQUEST = 'SEND_EMAIL_REQUEST';
export const SEND_EMAIL_SUCCESS = 'SEND_EMAIL_SUCCESS';
export const SEND_EMAIL_FAILURE = 'SEND_EMAIL_FAILURE';
export const SEND_ALL_EMAIL_REQUEST = 'SEND_ALL_EMAIL_REQUEST';
export const SEND_ALL_EMAIL_SUCCESS = 'SEND_ALL_EMAIL_SUCCESS';
export const SEND_ALL_EMAIL_FAILURE = 'SEND_ALL_EMAIL_FAILURE';

export const EXPORT_DRAFT_EMAILS_CSV_REQUEST =
  'EXPORT_DRAFT_EMAILS_CSV_REQUEST';
export const EXPORT_DRAFT_EMAILS_CSV_SUCCESS =
  'EXPORT_DRAFT_EMAILS_CSV_SUCCESS';
export const EXPORT_DRAFT_EMAILS_CSV_FAILURE =
  'EXPORT_DRAFT_EMAILS_CSV_FAILURE';

export const EXPORT_SENT_EMAILS_CSV_REQUEST = 'EXPORT_SENT_EMAILS_CSV_REQUEST';
export const EXPORT_SENT_EMAILS_CSV_SUCCESS = 'EXPORT_SENT_EMAILS_CSV_SUCCESS';
export const EXPORT_SENT_EMAILS_CSV_FAILURE = 'EXPORT_SENT_EMAILS_CSV_FAILURE';

export const CLEAR_EXPORT_DRAFT_STATE = 'CLEAR_EXPORT_DRAFT_STATE';
export const CLEAR_EXPORT_SENT_STATE = 'CLEAR_EXPORT_SENT_STATE';
export const CLEAR_SEND_TEST_EMAIL_STATE = 'CLEAR_SEND_TEST_EMAIL_STATE';
export const CLEAR_SEND_EMAIL_STATE = 'CLEAR_SEND_EMAIL_STATE';

export const SEND_TEST_EMAIL_REQUEST = 'SEND_TEST_EMAIL_REQUEST';
export const SEND_TEST_EMAIL_SUCCESS = 'SEND_TEST_EMAIL_SUCCESS';
export const SEND_TEST_EMAIL_FAILURE = 'SEND_TEST_EMAIL_FAILURE';

export const GET_EMAIL_VIEW_REQUEST = 'GET_EMAIL_VIEW_REQUEST';
export const GET_EMAIL_VIEW_SUCCESS = 'GET_EMAIL_VIEW_SUCCESS';
export const GET_EMAIL_VIEW_FAILURE = 'GET_EMAIL_VIEW_FAILURE';

// Action Interfaces
export interface GetEmailSentHistoryRequestAction {
  type: typeof GET_EMAIL_SENT_HISTORY_REQUEST;
  payload: { campaignId: string; filters?: EmailSentHistoryFilters };
  [key: string]: any;
}

export interface GetEmailSentHistorySuccessAction {
  type: typeof GET_EMAIL_SENT_HISTORY_SUCCESS;
  payload: EmailSentHistoryResponse;
  [key: string]: any;
}

export interface GetEmailSentHistoryFailureAction {
  type: typeof GET_EMAIL_SENT_HISTORY_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface ClearEmailSentHistorySuccessAction {
  type: typeof CLEAR_EMAIL_SENT_HISTORY_SUCCESS;
  [key: string]: any;
}

export interface GetDraftEmailsRequestAction {
  type: typeof GET_DRAFT_EMAILS_REQUEST;
  payload: { campaignId: string; filters?: EmailSentHistoryFilters };
  [key: string]: any;
}

export interface GetDraftEmailsSuccessAction {
  type: typeof GET_DRAFT_EMAILS_SUCCESS;
  payload: EmailSentHistoryResponse;
  [key: string]: any;
}

export interface GetDraftEmailsFailureAction {
  type: typeof GET_DRAFT_EMAILS_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface ClearDraftEmailsSuccessAction {
  type: typeof CLEAR_DRAFT_EMAILS_SUCCESS;
  [key: string]: any;
}

export interface SendEmailRequestAction {
  type: typeof SEND_EMAIL_REQUEST;
  payload: { emailId: string };
  [key: string]: any;
}

export interface SendEmailSuccessAction {
  type: typeof SEND_EMAIL_SUCCESS;
  payload: { emailId: string; message: string };
  [key: string]: any;
}

export interface SendEmailFailureAction {
  type: typeof SEND_EMAIL_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface SendAllEmailRequestAction {
  type: typeof SEND_ALL_EMAIL_REQUEST;
  payload: { campaignId: string };
  [key: string]: any;
}

export interface SendAllEmailSuccessAction {
  type: typeof SEND_ALL_EMAIL_SUCCESS;
  payload: { campaignId: string; message: string };
  [key: string]: any;
}

export interface SendAllEmailFailureAction {
  type: typeof SEND_ALL_EMAIL_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface ExportDraftEmailsCSVRequestAction {
  type: typeof EXPORT_DRAFT_EMAILS_CSV_REQUEST;
  payload: { campaignId: string; startDate?: string; endDate?: string };
  [key: string]: any;
}

export interface ExportDraftEmailsCSVSuccessAction {
  type: typeof EXPORT_DRAFT_EMAILS_CSV_SUCCESS;
  payload: Blob;
  [key: string]: any;
}

export interface ExportDraftEmailsCSVFailureAction {
  type: typeof EXPORT_DRAFT_EMAILS_CSV_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface ExportSentEmailsCSVRequestAction {
  type: typeof EXPORT_SENT_EMAILS_CSV_REQUEST;
  payload: { campaignId: string; startDate?: string; endDate?: string };
  [key: string]: any;
}

export interface ExportSentEmailsCSVSuccessAction {
  type: typeof EXPORT_SENT_EMAILS_CSV_SUCCESS;
  payload: Blob;
  [key: string]: any;
}

export interface ExportSentEmailsCSVFailureAction {
  type: typeof EXPORT_SENT_EMAILS_CSV_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface ClearExportDraftStateAction {
  type: typeof CLEAR_EXPORT_DRAFT_STATE;
  [key: string]: any;
}

export interface ClearExportSentStateAction {
  type: typeof CLEAR_EXPORT_SENT_STATE;
  [key: string]: any;
}

export interface ClearSendTestEmailStateAction {
  type: typeof CLEAR_SEND_TEST_EMAIL_STATE;
  [key: string]: any;
}

export interface ClearSendEmailStateAction {
  type: typeof CLEAR_SEND_EMAIL_STATE;
  [key: string]: any;
}

export interface SendTestEmailRequestAction {
  type: typeof SEND_TEST_EMAIL_REQUEST;
  payload: {
    senderAccountId: string;
    emailTemplateId: string;
    contactId: string;
    emailAddress: string[];
  };
  [key: string]: any;
}

export interface SendTestEmailSuccessAction {
  type: typeof SEND_TEST_EMAIL_SUCCESS;
  payload: { message: string };
  [key: string]: any;
}

export interface SendTestEmailFailureAction {
  type: typeof SEND_TEST_EMAIL_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface GetEmailViewRequestAction {
  type: typeof GET_EMAIL_VIEW_REQUEST;
  payload: { emailId: string };
  [key: string]: any;
}

export interface GetEmailViewSuccessAction {
  type: typeof GET_EMAIL_VIEW_SUCCESS;
  payload: { message: string; data: any };
  [key: string]: any;
}

export interface GetEmailViewFailureAction {
  type: typeof GET_EMAIL_VIEW_FAILURE;
  payload: string;
  [key: string]: any;
}

export type EmailSentHistoryActionTypes =
  | GetEmailSentHistoryRequestAction
  | GetEmailSentHistorySuccessAction
  | GetEmailSentHistoryFailureAction
  | ClearEmailSentHistorySuccessAction
  | GetDraftEmailsRequestAction
  | GetDraftEmailsSuccessAction
  | GetDraftEmailsFailureAction
  | ClearDraftEmailsSuccessAction
  | SendEmailRequestAction
  | SendEmailSuccessAction
  | SendEmailFailureAction
  | SendAllEmailRequestAction
  | SendAllEmailSuccessAction
  | SendAllEmailFailureAction
  | ExportDraftEmailsCSVRequestAction
  | ExportDraftEmailsCSVSuccessAction
  | ExportDraftEmailsCSVFailureAction
  | ExportSentEmailsCSVRequestAction
  | ExportSentEmailsCSVSuccessAction
  | ExportSentEmailsCSVFailureAction
  | ClearExportDraftStateAction
  | ClearExportSentStateAction
  | ClearSendTestEmailStateAction
  | ClearSendEmailStateAction
  | SendTestEmailRequestAction
  | SendTestEmailSuccessAction
  | SendTestEmailFailureAction
  | GetEmailViewRequestAction
  | GetEmailViewSuccessAction
  | GetEmailViewFailureAction;
